import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { buttonStyles } from "../components/ui";

export function NotFoundPage() {
  const { t } = useTranslation("settings");
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 px-4 text-center">
      <p className="font-mono text-sm text-fg-subtle">404</p>
      <h1 className="text-2xl font-semibold tracking-tight">{t("notFound.title")}</h1>
      <Link to="/apps" className={buttonStyles("secondary")}>
        {t("notFound.back")}
      </Link>
    </div>
  );
}
